import React, { useMemo } from "react";
import "./CardEmployees.scss";
import { Badge, Skeleton } from "antd";
import { useSelector } from "react-redux";
import { calculateMonthHoursAllEmp } from "./utils/calculations";
import { HollowDotsSpinner } from "react-epic-spinners";
import dayjsTZ from "../../../../../utils/dayjs";

const BADGE_COLORS = [
  "#7AC14D",
  "#FCC94A",
  "#BCBCBC",
  "#F04F4E",
  "#840032",
  "#ADD9F4",
  "#B0E298",
];

const TOP_N = 40;

const Employees = () => {
  const { employees } = useSelector((state) => state.employeesList);
  const { clockings } = useSelector((state) => state.clockings);

  const calculations = useMemo(() => {
    if (!employees || !clockings) return null;
    const temp = calculateMonthHoursAllEmp(employees, clockings, dayjsTZ()) || [];
    const withTotal = [
      ...temp,
      {
        employeeFirstName: "TOTAL",
        employeeLastName: "",
        employeeId: "__total__",
        totalHours: temp.reduce((acc, curr) => acc + (curr?.totalHours || 0), 0),
      },
    ];
    return withTotal;
  }, [employees, clockings]);

  const visibleRows = useMemo(() => {
    if (!calculations) return [];
    const rows = calculations.filter((el) => el.employeeFirstName !== null);
    const total = rows.find((r) => r.employeeId === "__total__");
    const people = rows
      .filter((r) => r.employeeId !== "__total__")
      .slice(0, TOP_N);
    return total ? [...people, total] : people;
  }, [calculations]);

  return (
    <>
      {!!employees && !!clockings && !!calculations ? (
        <div style={{ width: "100%", height: "100%", overflowY: "scroll" }}>
          <div className="employee-card">
            <span className="title-text">Punonjësit</span>
            <span className="report">
              <span className="title-text">Orët Mujore</span>
            </span>
          </div>
          <div className="content">
            {visibleRows.length ? (
              visibleRows.map((el) => (
                <div
                  key={el.employeeId || `${el.employeeFirstName}-${el.employeeLastName}`}
                  className="employee-card-content"
                  style={{
                    width: "330px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Badge
                    className="name-badger"
                    color={colorForEmployee(el.employeeId || el.employeeFirstName)}
                    text={`${el?.employeeFirstName} ${el?.employeeLastName} `}
                  />
                  <span
                    className="line-span"
                    style={{
                      display: "inline-block",
                      width: 125,
                      borderBottom: "1px solid rgba(0,0,0,.06)",
                      lineHeight: 0,
                      color: "#BCBCBC",
                    }}
                  >
                    &nbsp;
                  </span>
                  <span className="number-em">
                    {el.totalHours.toFixed(2)}
                  </span>
                </div>
              ))
            ) : (
              <div style={{ margin: "0 20px 0 20px" }}>
                <Skeleton />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <HollowDotsSpinner color="#1da193" size={24} />
        </div>
      )}
    </>
  );
};

export const colorForEmployee = (id) => {
  if (!id) return BADGE_COLORS[0];
  let hash = 0;
  const s = String(id);
  for (let i = 0; i < s.length; i++) {
    hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
  }
  return BADGE_COLORS[hash % BADGE_COLORS.length];
};

/** @deprecated Prefer colorForEmployee for stable colors */
export const getRandomColor = () => {
  return BADGE_COLORS[Math.floor(Math.random() * BADGE_COLORS.length)];
};

export default Employees;
